import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	name: '',
	date: '',
	startTime: '',
	endTime: '',
	filters: {
		court: '',
		fromDate: '',
		toDate: ''
	},
	filteredSearch: false,
	currentSettings: [],
	filteredCurrentSettings: [],
	refreshCourtSettings: false,
	syncFormValuesTrigger: 0,
	clearFormValuesTrigger: 0
};

const courtCalendarSlice = createSlice({
	initialState,
	name: 'courtCalendarSlice',
	reducers: {
		criminalDocket: (state, action) => {
			state = action.payload;
		},
		clearAll: (state) => {
			state.filters = {
				court: '',
				fromDate: '',
				toDate: ''
			};
		},
		addFilter: (state, action) => {
			state.filters[`${action.payload?.[0]}`] = action.payload?.[1];
		},
		addFilters: (state, action) => {
			state.filters = { ...state.filters, ...action.payload };
		},
		filteredSearch: (state) => {
			state.filteredSearch = !state.filteredSearch;
		},
		currentSettings: (state, action) => {
			state.currentSettings = action.payload;
		},
		filteredCurrentSettings: (state, action) => {
			state.filteredCurrentSettings = action.payload;
		},
		refreshCourtSettings: (state, action) => {
			state.refreshCourtSettings = action.payload;
		},
		triggerSyncFormValues: (state) => {
			state.syncFormValuesTrigger = state.syncFormValuesTrigger + 1;
		},
		triggerClearFormValues: (state) => {
			state.clearFormValuesTrigger = state.clearFormValuesTrigger + 1;
		}
	}
});

export const {
	criminalDocket,
	clearAll,
	addFilter,
	addFilters,
	filteredSearch,
	currentSettings,
	filteredCurrentSettings,
	refreshCourtSettings,
	triggerSyncFormValues,
	triggerClearFormValues
} = courtCalendarSlice.actions;

export default courtCalendarSlice.reducer;
